import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';

const CapabilityCard = props => {
    const {title, cta, cardcopy, image} = props || {};
    const renderImage = () => {
        const {mediaDetails, mediaItemUrl, altText} = image?.node || {};
        if(!image?.node?.mediaItemUrl) return false;

        return (
            <Link className={styles.capCard__imageLink} href={cta?.url || `#`}>
                <Image priority loading={'eager'}  width={mediaDetails?.width}  height={mediaDetails?.height} alt={altText || title} src={mediaItemUrl}  className={styles.capCard__image} />
            </Link>
        );
    }

    const renderMeta = () => {
        return (
            <div className={styles.capCard__meta}>
                <Link className={`${styles.capCard__meta}`} href="#">
                    Capability
                </Link>
            </div>
        );
    }

    const renderTitle = () => {
        if(!title) return false;

        return (
            <h3 className={`${styles.capCard__title}`}>
                {title}
            </h3>
        );
    }

    const renderCopy = () => {
        if(!cardcopy) return false;
        return (
            <div className={`${styles.capCard__copy}`} dangerouslySetInnerHTML={{__html: cardcopy || " "}} />           
        );
    }

    const renderCta = () => {
        const {url, title} = cta || {};
        if(!cta?.url || !cta?.title) return false;
        return (
            <Link href={url || `#`}  className={`${styles.capCard__cta} cta_arrow`}>
                <span>
                    {title}
                </span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050"/>
                </svg>
            </Link>            
        );        
    }

    return (
        <article className={styles.capCard}>
            <div className={styles.capCard_inner}>
                {renderImage()}
                <div className={styles.capCard__content}>
                    {renderMeta()}
                    {renderTitle()}
                    {renderCopy()}
                    {renderCta()}
                </div>
            </div>
        </article>
    );
}

export default CapabilityCard;